import React from 'react';

interface EstadoVazioProps {
  /** Ícone já dimensionado (w-8 h-8) e colorido pelo call site. */
  icone: React.ReactNode;
  titulo: string;
  descricao?: React.ReactNode;
  /** Botão ou link opcional embaixo. */
  acao?: React.ReactNode;
  /** Cor da caixa do ícone. Sage quando o vazio é boa notícia (acesso liberado). */
  corCaixa?: string;
  className?: string;
}

/**
 * "Nenhum produto ainda", "Nenhum registro ainda", "Nenhuma foto encontrada".
 *
 * Eram 5 cópias do mesmo markup, todas aparecendo sem nenhuma animação — o vazio
 * é justamente o que chega DEPOIS do esqueleto, então era o corte mais visível
 * da tela. A entrada mora aqui e vale para todas.
 */
export default function EstadoVazio({
  icone,
  titulo,
  descricao,
  acao,
  corCaixa = 'bg-nude-100 dark:bg-gray-800',
  className = '',
}: EstadoVazioProps) {
  return (
    <div className={`animate-enter flex flex-col items-center gap-4 py-16 text-center ${className}`}>
      <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${corCaixa}`}>
        {icone}
      </div>
      <div>
        <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">{titulo}</p>
        {descricao && (
          <p className="text-xs text-nude-400 dark:text-gray-500 mt-1">{descricao}</p>
        )}
      </div>
      {acao}
    </div>
  );
}
